// extracted by mini-css-extract-plugin
export var card = "_kp-5";
export var cardSelected = "_kp-4";
export var image = "_kp-3";
export var modal = "_kp-0";
export var modalContent = "_kp-1";
export var table = "_kp-2";